var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ui-checkbox-field ui-field ui-option-field control" },
    [
      _c("div", { staticClass: "ui-option-field-wrapper" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.aValue,
              expression: "aValue",
            },
          ],
          attrs: {
            type: "checkbox",
            id: _vm.id,
            required: _vm.$props.required,
            value: "true",
          },
          domProps: {
            checked: Array.isArray(_vm.aValue)
              ? _vm._i(_vm.aValue, "true") > -1
              : _vm.aValue,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.aValue,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = "true",
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.aValue = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.aValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.aValue = $$c
              }
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "ui-checkbox-state-indicator ui-option-state-indicator",
          },
          [
            _c("svg", { attrs: { viewBox: "0 0 14 14" } }, [
              _c("path", {
                staticClass: "ui-checkbox-checkmark-path",
                attrs: { fill: "none", d: "M1.01,7.53l3.72,3.72l8.57-8.5" },
              }),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass:
            "ui-checkbox-secondary-indicator ui-option-secondary-indicator",
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ui-option-label" }, [
        _c("label", { attrs: { for: _vm.id } }, [
          _vm._v("\n      " + _vm._s(_vm.$props.label) + "\n      "),
          _vm.description
            ? _c("div", { staticClass: "field-description" }, [
                _vm._v(_vm._s(_vm.description)),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }